import { useTranslation } from 'react-i18next'

import Section from '@/components/atomic/molecules/Section'
import TagList from '@/components/atomic/organisms/TagList'
import Text from '@/components/atomic/atoms/Text'

import type { HospitalView } from '@/features/hospital/types/hospital.type'

interface HospitalLoanSectionProps {
  hospital: HospitalView
}

export const HospitalLoanSection = ({ hospital }: HospitalLoanSectionProps) => {
  const { t } = useTranslation()

  return (
    <Section title={t('templates.hospitalDetail.loanTitle')}>
      <TagList
        tags={
          hospital.payment.medicalLoan?.enabled
            ? [t('templates.hospitalDetail.loan.possible')]
            : [t('templates.hospitalDetail.loan.impossible')]
        }
      />
      {hospital.payment.medicalLoan?.comment && (
        <Text element="p" type="caption2">
          {hospital.payment.medicalLoan?.comment}
        </Text>
      )}
    </Section>
  )
}
